export default __webpack_public_path__ + "static/civi-e17e3f94e59ad0b9f0c96143a4692f93.png";